export const springs = {
  /** Fast, no overshoot. Buttons, toggles, micro-feedback. */
  snappy: { type: "spring" as const, damping: 30, stiffness: 400 },

  /** Balanced, slight overshoot. Panels, cards entering, view transitions. */
  smooth: { type: "spring" as const, damping: 25, stiffness: 300 },

  /** Visible overshoot, playful. FAB entrance, celebration moments, checkbox pops. */
  bouncy: { type: "spring" as const, damping: 18, stiffness: 280 },

  /** Very gentle, for slow reveals and ambient effects. */
  gentle: { type: "spring" as const, damping: 30, stiffness: 180 },
};
